import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllService } from "../ServiceAPI/services/api";

const Footer = () => {
  const [subServices, setSubServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getAllService();
        let serviceArray = [];
        if (Array.isArray(data)) {
          serviceArray = data;
        } else if (data.services && Array.isArray(data.services)) {
          serviceArray = data.services;
        } else if (data.data && Array.isArray(data.data)) {
          serviceArray = data.data;
        }

        // Extract unique "Type" as sub-links, and their associated "Name" for routing
        const uniqueTypes = [];
        const seenTypes = new Set();

        serviceArray.forEach(item => {
          if (item.Type && !seenTypes.has(item.Type)) {
            uniqueTypes.push({
              displayName: item.Type,
              apiName: item.Name
            });
            seenTypes.add(item.Type);
          }
        });

        setSubServices(uniqueTypes);
      } catch (err) {
        console.error('Error fetching services for footer:', err);
        // Fallback
        setSubServices([
          { displayName: 'New License', apiName: 'License' },
          { displayName: 'Renew License', apiName: 'License' },
          { displayName: 'Tax Payment', apiName: 'Vehicle Registration' }
        ]);
      }
    };
    fetchServices();
  }, []);
  return (
    <footer className="bg-blue-900 text-white mt-12">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

        {/* Column 1 */}
        {/* <div>
          <h3 className="text-xl font-bold mb-4">RTO Bharat</h3>
          <p className="text-gray-400">
            Your one-stop solution for all RTO services in India.
          </p>
        </div> */}

        {/* Column 3 */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Services</h4>
          <ul className="space-y-2 text-gray-400">
            {subServices.length > 0 ? (
              subServices.map((service, index) => (
                <li key={index}>
                  <Link
                    to={`/service-type/${encodeURIComponent(service.apiName)}`}
                    className="hover:text-blue-300 transition-colors"
                  >
                    {service.displayName}
                  </Link>
                </li>
              ))
            ) : (
              <>
                <li>New License</li>
                <li>Renew License</li>
                <li>License Renewal</li>
                <li>Vehicle Registration</li>
              </>
            )}
            <li>
              <span className="hover:text-blue-300 transition-colors cursor-default">
                Vehicle Insurance
              </span>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Contact Information</h4>
          <p className="text-gray-400">Kestopur Chandiberia, Near Power House, P.S. New Town, North 24 Parganas, West Bengal – 700102, India</p>
          <p className="text-gray-400">Email: <a href="mailto:contact@rtobharat.com" className="hover:text-blue-300">contact@rtobharat.com</a></p>
          <p className="text-gray-400">Telephone: +91 9477879491</p>
        </div>

        {/* Column 5 */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Business Hours</h4>
          <p className="text-gray-400">Monday – Friday: 09:00 AM to 07:00 PM</p>
          <p className="text-gray-400">Saturday: 10:00 AM to 05:00 PM</p>
          <p className="text-gray-400">Sunday: Closed</p>
        </div>

        {/* Column 6 */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Useful Links</h4>
          <ul className="space-y-2 text-gray-400">
            <li>
              <Link to='/admin/login' className='hover:text-blue-300'>
                Admin Login
              </Link>
            </li>
            <li>
              <Link to='/contact' className='hover:text-blue-500'>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to='/privacy-policy' className='hover:text-blue-500'>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to='/terms-and-conditions' className='hover:text-blue-500'>
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link to='/cancellation-policy' className='hover:text-blue-500'>
                Cancellation Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-800 text-gray-400 text-center py-4">
        &copy; {new Date().getFullYear()} RTO Bharat. All rights reserved. | Developed by Priyashree Banerjee.
      </div>
    </footer>
  );
};

export default Footer;
